import type { ChangelogEvent } from "@poi-planner/shared";
import { isActivityFeedInverseAction } from "@poi-planner/shared";

export type ActivityControl = {
  action: "undo" | "redo";
  disabled: boolean;
  reason: string | null;
};

export function getActivityControl(
  event: ChangelogEvent,
  events: ChangelogEvent[],
  localConflict?: string,
): ActivityControl | null {
  if (!event.undoable || !event.inverse?.action) return null;
  if (!isActivityFeedInverseAction(event.inverse.action)) return null;

  if (event.source === "mcp" && !event.originalActivityId) {
    const linked = events.find(
      (candidate) => candidate.originalActivityId === event.id,
    );
    const reason = localConflict ?? linked?.conflictReason ?? null;
    return {
      action: "undo",
      disabled: Boolean(linked) || Boolean(reason),
      reason:
        reason ??
        (linked?.action === "undo" && linked.outcome === "success"
          ? "This change has been undone."
          : linked?.action === "redo" && linked.outcome === "success"
            ? "This change has been redone."
            : null),
    };
  }

  if (event.action === "undo" && event.outcome === "success") {
    const linked = events.find((candidate) => candidate.redoOf === event.id);
    const reason = localConflict ?? linked?.conflictReason ?? null;
    return {
      action: "redo",
      disabled: Boolean(linked) || Boolean(reason),
      reason:
        reason ??
        (linked?.action === "redo" && linked.outcome === "success"
          ? "This change has been redone."
          : null),
    };
  }

  return null;
}
